/* PDP Phase 2: anchor real technical headings and keep the existing AI dock off purchase controls. */
(() => {
  const headingRules = [
    { id: 'features', title: 'Features', detail: 'Core capabilities', match: /^(key features|features|core diagnostic capabilities|diagnostic capabilities|product features)$/i },
    { id: 'specifications', title: 'Specs', detail: 'Technical specifications', match: /^(specifications|technical specifications|product specifications|technical overview|technical specs)$/i },
    { id: 'compatibility', title: 'Use cases', detail: 'Applications', match: /^(compatibility(?:\s*&\s*applications)?|vehicle compatibility|supported vehicles|vehicle coverage|applications|typical diagnostic applications|compatible vehicle types)$/i },
  ];

  const addAnchor = (heading, id) => {
    if (document.getElementById(id)) return;
    if (!heading.id) {
      heading.id = id;
    } else {
      const anchor = document.createElement('span');
      anchor.id = id;
      heading.before(anchor);
    }
  };

  const addQuickLink = (nav, rule, href) => {
    const link = document.createElement('a');
    link.className = 'obr-pdp-quick-facts__item';
    link.href = href;
    link.dataset.fact = rule.id;
    const title = document.createElement('span');
    title.className = 'obr-pdp-quick-facts__title';
    title.textContent = rule.title;
    const detail = document.createElement('span');
    detail.className = 'obr-pdp-quick-facts__detail';
    detail.textContent = rule.detail;
    link.append(title, detail);
    nav.insertBefore(link, nav.querySelector('.obr-pdp-quick-facts__item:not([data-fact])'));
  };

  const initFacts = (scope = document) => {
    const nav = scope.querySelector?.('[data-obr-pdp-quick-facts]');
    if (!nav || nav.dataset.ready === 'true') return;
    const productInfo = nav.closest('product-info');
    const headings = [...(productInfo?.querySelectorAll('.obr-pdp-content h2, .obr-pdp-content h3, .product__description h2, .product__description h3, .product__accordion h2') || [])];
    for (const rule of headingRules) {
      const heading = headings.find((item) => rule.match.test(item.textContent.trim().replace(/\s+/g, ' ')));
      if (heading) addAnchor(heading, rule.id);
      const href = rule.id === 'compatibility' && nav.dataset.compatibilityUrl ? nav.dataset.compatibilityUrl : heading ? `#${rule.id}` : '';
      if (href) addQuickLink(nav, rule, href);
    }
    const faq = headings.find((item) => /^faq|frequently asked questions$/i.test(item.textContent.trim()));
    if (faq) addAnchor(faq, 'faq');
    const reviews = document.getElementById('judgeme_product_reviews');
    if (reviews && !document.getElementById('reviews')) {
      const anchor = document.createElement('span');
      anchor.id = 'reviews';
      reviews.before(anchor);
    }
    if (reviews) {
      document.querySelectorAll('a[href="#judgeme_product_reviews"], a[href$="#judgeme_product_reviews"]').forEach((link) => {
        link.setAttribute('href', '#reviews');
      });
    }
    nav.dataset.ready = 'true';
  };

  let aiFrame = 0;
  const clearAiPurchaseControls = () => {
    aiFrame = 0;
    const dock = document.querySelector('.chatty-ai-mode.state-resting.pos-bottom .aimode-sbar-dock');
    if (!dock || !document.body.classList.contains('template-product') || innerWidth > 749) return;
    const dockRect = dock.getBoundingClientRect();
    const purchase = [...document.querySelectorAll('.product-form__quantity, .product-form__buttons, .obd-sticky-atc.is-visible .obd-sticky-atc__submit')]
      .map((element) => element.getBoundingClientRect())
      .filter((rect) => rect.bottom > 0 && rect.top < innerHeight && rect.width > 0);
    const stickyVisible = document.documentElement.classList.contains('obd-sticky-atc-visible');
    const offsets = stickyVisible ? [104, 188, 272, 356, 440] : [20, 104, 188, 272, 356, 440];
    const dockLeft = dockRect.left;
    const dockRight = dockRect.right;
    const chosen = offsets.find((bottom) => {
      const top = innerHeight - bottom - dockRect.height;
      return top > 11 && purchase.every((rect) =>
        rect.right < dockLeft - 8 || rect.left > dockRight + 8 || rect.bottom < top - 8 || rect.top > top + dockRect.height + 8
      );
    }) || offsets[offsets.length - 1];
    document.body.style.setProperty('--obr-pdp-ai-bottom', `${chosen}px`);
  };

  const scheduleAi = () => {
    if (!aiFrame) aiFrame = requestAnimationFrame(clearAiPurchaseControls);
  };

  const boot = () => {
    initFacts();
    scheduleAi();
    setTimeout(scheduleAi, 800);
    setTimeout(scheduleAi, 2500);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('scroll', scheduleAi, { passive: true });
  window.addEventListener('resize', scheduleAi);
  new MutationObserver(scheduleAi).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('shopify:section:load', (event) => { initFacts(event.target); scheduleAi(); });
})();
